import React, {Component} from "react";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import PictureGallery from "../picture/PictureGallery";
import Constants from "../../../services/Constants";

class IdentityDocuments extends Component {

  handleDeletePhoto = (attachment) => {
    const {uuid} = this.props;
    const {key} = attachment;
    this.props.onDeletePhoto({uuid, key});
  }

  render() {
    const {intl: {formatMessage}, identityDocuments, canWrite} = this.props;

    const count = identityDocuments ? identityDocuments.attachments.length : 0;

    return (
      <React.Fragment>
        <h5 className="choice-card__subtitle">
          {formatMessage({id:'appointment.detail.mobility.mobility-solution.attachments.title'}, {max:Constants.MAX_ID_PICTURES, count})}&nbsp;
          <svg className="bmw-icon bmw-icon-md " aria-hidden="true">
          </svg>
        </h5>
        <PictureGallery pictures={identityDocuments && identityDocuments.attachments || []} displayMissing={Constants.MAX_ID_PICTURES} allowDelete={canWrite} onDelete={this.handleDeletePhoto}/>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(IdentityDocuments))



// WEBPACK FOOTER //
// ./src/components/interventiondetail/mobility/IdentityDocuments.js